module.exports = fox._r("images/valentines18/gift-47.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines18/gift-47.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines18/gift-47.png
// module id = 248
// module chunks = 4